import type { NavGroup, NavLink } from '../types/navigation';

export const navGroups: NavGroup[] = [
  {
    label: 'La Banque',
    path: '/la-banque',
    intro: 'Une banque mauritanienne engagée auprès de ses clients.',
    links: [
      { label: 'Présentation', path: '/la-banque/presentation', description: 'Notre identité, nos valeurs, nos métiers' },
      { label: 'Mot du Président', path: '/la-banque/mot-du-president', description: 'La vision de la direction' },
      { label: 'Gouvernance', path: '/la-banque/gouvernance', description: "Conseil d'administration et direction" },
      { label: 'Historique', path: '/la-banque/historique', description: 'Les grandes dates de la banque' },
      { label: "Réseau d'agences", path: '/la-banque/agences', description: 'Trouvez une agence près de chez vous' },
      { label: 'Carrières', path: '/la-banque/carrieres', description: 'Rejoindre nos équipes' },
      { label: 'Actualités', path: '/la-banque/actualites', description: 'Communiqués et nouveautés' },
    ],
  },
  {
    label: 'Particuliers',
    path: '/particuliers',
    intro: 'Comptes, épargne, crédits et cartes pour votre quotidien.',
    links: [
      { label: 'Comptes courants', path: '/particuliers/comptes', description: 'Gérer votre argent au quotidien' },
      { label: 'Compte El-Haçad', path: '/particuliers/compte-el-hacad', description: 'Épargne islamique rentable et sûre' },
      { label: 'Épargne', path: '/particuliers/epargne', description: 'Faire fructifier vos économies' },
      { label: 'Crédits', path: '/particuliers/credits', description: 'Personnel, renouvelable, auto, travaux' },
      { label: 'Cartes GIMTEL', path: '/particuliers/cartes', description: 'Payer et retirer partout' },
      { label: 'Transferts', path: '/particuliers/transferts', description: 'Envoyer et recevoir de l’argent' },
    ],
  },
  {
    label: 'Entreprises & Pros',
    path: '/entreprises',
    intro: 'Des solutions pour financer et piloter votre activité.',
    links: [
      { label: 'Comptes professionnels', path: '/entreprises/comptes', description: 'Pour commerçants, PME et grandes entreprises' },
      { label: 'Financement', path: '/entreprises/financement', description: 'Investissement et exploitation' },
      { label: 'Commerce international', path: '/entreprises/international', description: 'Crédits documentaires, remises' },
      { label: 'Gestion de trésorerie', path: '/entreprises/tresorerie', description: 'Optimiser vos flux' },
      { label: 'Cautions & garanties', path: '/entreprises/cautions', description: 'Marchés publics et privés' },
    ],
  },
  {
    label: 'Finance Islamique',
    path: '/finance-islamique',
    intro: 'Des produits conformes aux principes de la Charia.',
    links: [
      { label: 'Nos principes', path: '/finance-islamique/principes', description: 'Une banque responsable et éthique' },
      { label: 'Mourabaha', path: '/finance-islamique/mourabaha', description: 'Financement d’acquisition' },
      { label: 'Ijara', path: '/finance-islamique/ijara', description: 'Location avec option d’achat' },
      { label: 'Moucharaka', path: '/finance-islamique/moucharaka', description: 'Partenariat et partage' },
      { label: 'Comité Charia', path: '/finance-islamique/comite-charia', description: 'Supervision et conformité' },
    ],
  },
  {
    label: 'Digital',
    path: '/digital',
    intro: 'Votre banque disponible 24h/24, où que vous soyez.',
    links: [
      { label: 'Chinguitty Online', path: '/digital/chinguitty-online', description: 'Votre banque en ligne' },
      { label: 'Chinguitty SMS', path: '/digital/chinguitty-sms', description: 'Alertes et soldes par SMS' },
      { label: 'Application mobile', path: '/digital/application', description: 'Gérer vos comptes depuis votre téléphone' },
      { label: 'Sécurité', path: '/digital/securite', description: 'Se protéger contre la fraude' },
    ],
  },
];

export const serviceLinks: NavLink[] = [
  { label: 'Vente de terrains', path: '/vente-de-terrains', description: 'Lotissements proposés par la banque' },
  { label: 'Devenir client', path: '/devenir-client', description: 'Ouvrir un compte en quelques étapes' },
  { label: 'Accès à vos comptes', path: '/acces-comptes', description: 'Connexion à la banque en ligne' },
  { label: 'Contact', path: '/contact', description: 'Nous écrire, nous appeler' },
  { label: 'FAQ', path: '/faq', description: 'Les questions fréquentes' },
  { label: 'Tarifs & conditions', path: '/tarifs', description: 'Nos conditions générales' },
];

export const legalLinks: NavLink[] = [
  { label: 'Suppression de compte', path: '/suppression-de-compte', description: 'Demander la suppression de vos données' },
  { label: 'Politique de confidentialité', path: '/politique-de-confidentialite', description: 'Protection de vos données' },
  { label: 'Mentions légales', path: '/mentions-legales', description: 'Informations légales' },
];
